import type { LexicalEditor } from 'lexical';
import { COMMAND_PRIORITY_CRITICAL, KEY_ENTER_COMMAND } from 'lexical';

/**
 * Ctrl+Enter (⌘+Enter on macOS) submits; with `submitOnEnter` (single-line), so does a plain Enter.
 * - Critical priority, so it runs before the list, table and single-line Enter handlers.
 * - Ignored while an IME is composing, where Enter confirms the composition.
 * - Returns the unregister function, like Lexical's own `register*` helpers.
 */
export const registerSubmit = (editor: LexicalEditor, onSubmit: () => void, { submitOnEnter = false } = {}): (() => void) =>
  editor.registerCommand(
    KEY_ENTER_COMMAND,
    (event) => {
      if (!event || event.isComposing) return false;
      if (!submitOnEnter && !event.ctrlKey && !event.metaKey) return false;

      event.preventDefault();
      onSubmit();
      return true;
    },
    COMMAND_PRIORITY_CRITICAL,
  );
